import contains from '@mui/utils/contains';

export default contains;
